import Project1 from "../../Assets/Images/Project1.png";
import Project2 from "../../Assets/Images/Project2.png";
import Project3 from "../../Assets/Images/Project3.png";
export const projects = [
  {
    id: 1,
    title: "FRONTENDS PROJECTS | Ed-Tech Platform",
    subTitle: "Created this platform to share projects with tutorial",
    img: Project1,
    igUrl: "https://www.instagram.com/frontendsprojects/",
    viewUrl: "https://frontendsprojects.com/",
  },
  {
    id: 2,
    title: "CODINGSUMIT | Tech Blog",
    subTitle: "Created this blog to share web dev tutorial tips and tricks",
    img: Project2,
    igUrl: "https://www.instagram.com/codingsumit/",
    viewUrl: "https://codingsumit.com/",
  },
  {
    id: 3,
    title: "CELEBRITY INFORMATION | API PROJECT ",
    subTitle: "Created this project using Ninja API ",
    img: Project3,
    gitUrl: "https://github.com/smthari/celebrity-database",
    viewUrl: "https://celebrity-database.netlify.app/",
  },
];
